export enum ANAMNESE_STATUS {
  ANSWERED_YES = 'RS',
  NOT_ANSWERED = 'NR',
  ALL_RIGHT = 'TC',
}
